import React, { memo, useMemo } from "react"
import { Col, Row } from "react-bootstrap"
import { hasHtmlTags, sanitizeHtml } from "@/helpers/htmlUtils"

export const DashboardRow = memo(({ title, children, titleFontWeight = "normal", titleSpace = 8 }) => {
  const { needsSanitization, content } = useMemo(
    () => ({
      needsSanitization: hasHtmlTags(children),
      content: hasHtmlTags(children) ? sanitizeHtml(children) : children,
    }),
    [children]
  )

  return (
    <Row className="mb-2">
      <Col lg={titleSpace}>
        <div className={`font-size-medium font-weight-${titleFontWeight} text-gray`}>{title}</div>
      </Col>

      <Col lg={24 - titleSpace}>
        <div
          className="font-size-medium extra-dark-gray"
          {...(needsSanitization ? { dangerouslySetInnerHTML: { __html: content } } : { children: content })}
        />
      </Col>
    </Row>
  )
})

DashboardRow.displayName = "DashboardRow"
